/* global $:false */

export default class Toggler {
  static init () {
    new Toggler().init()
  }

  constructor () {
    this.toggler = $('[data-toggler]')
    this.togglerContents = $('[data-toggler-content]')
  }

  init () {
    this.setupToggler()
  }

  setupToggler () {
    return this.toggler.click(e => {
      const identifier = $(e.target).data('toggler')
      this.enableToggler(identifier)
    })
  }

  enableToggler (identifier) {
    this.showTogglerContents(identifier)
  }

  showTogglerContents (identifier) {
    $(`[data-toggler-content=${identifier}]`).slideToggle()
    $(`[data-toggler-content=${identifier}]`).toggleClass('c-toggler__content--active')
  }
}
